// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610011451/js/" + chunkId + "." + {"44":"a42aa52d","225":"bee92072","481":"60e74917","486":"31768095","770":"46525223"}[chunkId] + ".0.08876740341946188.chunk.js";
};